import {gql} from "@apollo/client";
import {Slot} from "@App/types";

export interface SlotQuery {
    slot: Slot
}

export const GET_SLOT = gql`
    query getSlot(
        $id: ID!,
        $sessionId: String!
    ) {
        slot(id: $id, session_id: $sessionId) {
            id
            calendar_id
            starts_at
            ends_at
        }
    }
`
